import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ma-2" }
const _hoisted_2 = { class: "ma-2" }
const _hoisted_3 = { class: "ma-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_ctx.patient)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "ma-0 mb-0 rounded-xl",
        variant: "outlined",
        color: "jamzcare"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "pb-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "primary mb-1" }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-account")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.patient.name) + " ", 1),
                      _createVNode(_component_v_chip, {
                        small: "",
                        class: "mb-0",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Female")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.patient.location)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "6",
                        class: "pb-0 text-right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_tooltip, {
                            text: "Patient's Ward",
                            location: "top"
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_chip, _mergeProps({
                                class: "mb-0",
                                color: "primary",
                                variant: "outlined"
                              }, props), {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    start: "",
                                    icon: "mdi-bed"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.patient.location), 1)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_tooltip, {
                            text: "Patient's Current Location",
                            location: "top"
                          }, {
                            activator: _withCtx(({ props }) => [
                              (_ctx.patient.currentLocation)
                                ? (_openBlock(), _createBlock(_component_v_chip, _mergeProps({
                                    key: 0,
                                    class: "ml-2 mb-0",
                                    color: "success",
                                    variant: "outlined"
                                  }, props), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        start: "",
                                        icon: "mdi-map-marker-radius"
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.patient.currentLocation), 1)
                                    ]),
                                    _: 2
                                  }, 1040))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "pt-4 pb-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "ml-1 mb-2 primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-cake-variant")
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.patient.birthdate) + ", age " + _toDisplayString(_ctx.patient.age), 1),
                      _createElementVNode("span", _hoisted_2, [
                        _createVNode(_component_v_icon, { class: "primary" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-card-account-details")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" HRN: " + _toDisplayString(_ctx.patient.hrn), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.patient.visitNumber)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "6",
                        class: "pt-4 pb-0 text-right"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_3, [
                            _createVNode(_component_v_tooltip, {
                              text: "Visit Number",
                              location: "top"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_chip, _mergeProps({
                                  small: "",
                                  class: "ma-0",
                                  color: "primary",
                                  label: ""
                                }, props), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      start: "",
                                      icon: "mdi-badge-account"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.patient.visitNumber), 1)
                                  ]),
                                  _: 2
                                }, 1040)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}